module.exports = __webpack_public_path__ + "static/media/flight-info-example-mobile.e05973eb.png";